import { render } from "./quoting-gas.vue?vue&type=template&id=2dd20685&scoped=true"
import script from "./quoting-gas.vue?vue&type=script&lang=js"
export * from "./quoting-gas.vue?vue&type=script&lang=js"

import "./quoting-gas.vue?vue&type=style&index=0&id=2dd20685&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd20685"]])

export default __exports__